<template>
  <div>
    <b-card
      no-body
      class="my-0"
      :class="{ 'card-transparent-background': type == 'register' }"
      ><b-card-header v-if="type == 'view'" class="card-header-profile-border">
        <b-row>
          <b-col> <h4>Order Numbeer</h4></b-col>
          <b-col class="text-right"
            ><h4 class="orderNumber">#{{ order_number }}</h4>
            <span :class="'orderStatusSpan ' + status + '_status'">{{
              status_str
            }}</span></b-col
          >
        </b-row>
      </b-card-header>

      <b-card-body
        class=""
        :class="{
          'p-2': type == 'profile' || type == 'edit',
          'py-0': type == 'register',
        }"
      >
        <div class="container">
          <b-row>
            <b-col :sm="type == 'view' ? '12' : '6'">
              <b-form-group
                class="form-group-doorder"
                label="Driver name"
                label-for="driver_name"
                label-class="form-label-doorder"
              >
                <span
                  v-if="type == 'view'"
                  class="form-control form-control-doorder"
                >
                  {{ driver_name }}
                </span>
              </b-form-group>
            </b-col>
          </b-row>
           <b-row>
            <b-col :sm="type == 'view' ? '12' : '6'">
              <b-form-group
                class="form-group-doorder"
                label="Delivery status"
                label-for="delivery_status"
                label-class="form-label-doorder"
              >
                <span
                  v-if="type == 'view'"
                  class="form-control form-control-doorder"
                >
                  {{ delivery_status }}
                </span>
              </b-form-group>
            </b-col>
          </b-row>
           <b-row>
            <b-col :sm="type == 'view' ? '12' : '6'">
              <b-form-group
                class="form-group-doorder"
                label="Delivery skip reason"
                label-for="delivery_skip_reason"
                label-class="form-label-doorder"
              >
                <span
                  v-if="type == 'view'"
                  class="form-control form-control-doorder"
                >
                  {{ delivery_skip_reason }}
                </span>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>

  </div>
</template>
<script>
import $ from "jquery";
import axios from "axios";

export default {
  name: "DriverDetailsHistory",
  components: {},
  props: ["type", "order_id", "order_number", "status_str", "status",
"driver_name","delivery_status","delivery_skip_reason"],
  data() {
    return {};
  },
  beforeMount() {},
  mounted() {},
  computed: {},
  watch: {},
  methods: {},
};
</script>



// WEBPACK FOOTER //
// src/components/doorder/orders/order_details_components/DriverDetailsHistory.vue